import UpsertWatchListEntryForm from './UpsertWatchListEntryForm';

export default UpsertWatchListEntryForm;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/components/upsert-watch-list-entry-form/index.js